import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  fetchListAllDocuments,
  filterListAllDocuments
} from '../../../../main/usecases'
import {
  DocumentsFetchModel,
  TypeToDocumentsModel,
  TypeToAvaliacaoModel
} from '../../../../domain/models'

import { goToUrl, formatDate } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import { Button, Table, EmptyData, InputFilter } from '../../../components'
import DeleteDocumentModal from './delete-documents'
import FilterCustomDocumentModal from './filter-custom-documents'

import {
  PlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../assets/icons/svgComponents'

import * as S from './styles'

type FilterValuesProps = {
  typeToService: string
  typeToDocument: string
}

const Documents = () => {
  const [documents, setDocuments] = useState<DocumentsFetchModel>()
  const [filterValues, setFilterValues] = useState<FilterValuesProps>()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const history = useHistory()
  const { modalBox } = useModalBox()
  const alert = useAlert()
  const { refresh } = useOnChangeDetect()

  const handleRemoveFilterDocuments = async () => {
    try {
      setFilterValues({ typeToService: '', typeToDocument: '' })

      const filterData = await filterListAllDocuments({
        typeToService: '',
        typeToDocument: '',
        page: page
      }).load()

      setDocuments(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao remover filtro', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleFilterDocuments = async () => {
    try {
      const filterData = await filterListAllDocuments({
        typeToService: filterValues?.typeToService || '',
        typeToDocument: filterValues?.typeToDocument || '',
        page: page
      }).load()

      setDocuments(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleClickNewClientRegister = () => {
    modalBox(<FilterCustomDocumentModal />, 'Personalize um modelo', '38%')
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Nome do documento',
        accessor: 'nameToDocument'
      },
      {
        Header: 'Nome do serviço',
        accessor: 'nameToService'
      },
      {
        Header: 'Data de atualização',
        accessor: 'dataUltimaModificao'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )

  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      typeToDocument: TypeToDocumentsModel,
      typeToService: TypeToAvaliacaoModel
    ) => {
      try {
        setLoading(true)

        goToUrl(history, `/documento`, {
          cdTypeToDocument:
            typeToDocument && typeToDocument.cdTipoDocumentoPsicologico,
          cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
          documentTitle: typeToDocument && typeToDocument.descricao,
          serviceTitle: typeToService && typeToService.tipoAvaliacao
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar modelo personalizado', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }

    const handleOpenDeleteModal = (
      cdTypeToService: number,
      cdTypeToDocument: number
    ) => {
      modalBox(
        <DeleteDocumentModal
          cdTypeToService={cdTypeToService}
          cdTypeToDocument={cdTypeToDocument}
        />,
        'Deletar documento personalizado',
        '32%'
      )
    }

    return documents?.content?.map((item) => {
      console.log(item)
      return {
        nameToDocument: item?.tipoDocumentoPsicologico.descricao,
        nameToService: item?.tipoAvaliacao.tipoAvaliacao,
        dataUltimaModificao: formatDate(item?.dataUltimaModificacao),
        actions: (
          <div className="table-icons">
            <button
              disabled={loading}
              onClick={() =>
                handleRedirectToRegistrationData(
                  item.tipoDocumentoPsicologico,
                  item.tipoAvaliacao
                )
              }
              title="Editar"
            >
              <IconEditSvg />
            </button>
            <div
              onClick={() =>
                handleOpenDeleteModal(
                  item.tipoAvaliacao.cdTipoAvaliacao,
                  item.tipoDocumentoPsicologico.cdTipoDocumentoPsicologico
                )
              }
            >
              <IconTrashSvg />
            </div>
          </div>
        )
      }
    })
  }, [documents?.content, modalBox, loading, alert, history])

  useEffect(() => {
    ;(async () => {
      try {
        const data = await fetchListAllDocuments({ page: page }).load()
        setDocuments(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [page, refresh])

  return (
    <S.Wrapper>
      <S.Title>Meus documentos</S.Title>
      <S.CardContainer>
        <S.ActionsContainer>
          <Button
            initialIcon={<PlusSvg />}
            onClick={handleClickNewClientRegister}
          >
            Personalize um modelo
          </Button>
          <InputFilter
            name="filter"
            type="text"
            optionsToRadio={[
              { name: 'typeToDocument', label: 'Tipo de documento' },
              { name: 'typeToService', label: 'Tipo de avaliação' }
            ]}
            placeholder="Pesquisar"
            onFilter={handleFilterDocuments}
            onRemove={handleRemoveFilterDocuments}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
          />
        </S.ActionsContainer>
        <S.TableContainer>
          {documents && documents?.content?.length ? (
            <Table
              onClick={() => ({})}
              columns={columns}
              dataTable={data}
              handlePageClick={(currentPage: any) =>
                setPage(currentPage.selected + 1)
              }
              pageCount={documents?.totalPages}
            />
          ) : documents?.empty && documents?.content?.length ? (
            <EmptyData>Não há nenhum documento para esse filtro</EmptyData>
          ) : (
            <EmptyData>
              Personalize um modelo de um documento de um serviço
            </EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Documents
